<template>
  <div class="video-box">
    <div class="video-box-bg"></div>
    <div id="player_container" class="video-area" :class="{isC:isAnswer}" style=""></div>
    <div class="video-close" v-if="!isAnswer" @click="closeVideo"></div>
    <div class="video-close-btn" v-if="isAnswer" @click="closeVideo">我来回答</div>
  </div>
</template>

<script>
export default {
  props: {
    guid: "",
    isAnswer:false
  },
  data() {
    return {
      player_single: ""
    };
  },
  mounted() {
    var that = this;
    var _player_width = 960; //播放器宽
    var _player_height = 540; //播放器高

    //移动端设置宽高，也可以自己定义宽高
    if (isIPad()) {
      var _player_width = document.body.clientWidth || window.innerWidth;
      var _player_height =
        document.documentElement.clientHeight || window.innerHeight;
      _player_width = parseInt(_player_width);
      _player_height = parseInt(_player_height);
      if (_player_width / _player_height < 1) {
        _player_height = (_player_width * 9) / 16;
      } else {
        _player_width = (_player_height * 16) / 9;
      }

      if (_player_width < 40 || _player_height < 30) {
        _player_width = 960;
        _player_height = 540;
      }
    }
    var isHttps = location.href.substr(0, 5) == "https" ? "true": "false";
    var playerParas = {
      divId: "player_container" /*播放器容器id，必填项*/,
      w: _player_width /*播放器宽度，必填项*/,
      h: _player_height /*播放器高度，必填项*/,
      t: "news" /*台名称，比如news,sports,tv等，必填项*/,
      videoCenterId: that.guid /*视频生产中心guid，必填项*/,
      br: "" /*设置默认码率*/,
      id: "null" /*可填null,必填项*/,
      videoId: "VIDE100215108600" /*视频集id*/,
      url:
        "" /*视频页面url，如http://tv.cntv.cn/video/C18472/a28126e5e0424a44af6a9bc4c5a47742*/,
      articleId: "" /*文章id*/,
      filePath: "" /*文件路径*/,
      sysSource: "" /*视频来源*/,
      channelId: "" /*可为空*/,
      scheduleId: "C18472000001" /*关键字*/,
      isLogin: "" /*用户中心相关，是否登录*/,
      userId: "" /*用户中心相关，用户登录id*/,
      start: "" /*从什么时间开始播，单位秒*/,
      isDefaultPreImage: "true" /*是否默认从vdn取图，非自动播放情况下才有效*/,
      isAutoPlay:
        "true" /*是否自动播放，只有false为不自动播放，其它值为自动播放*/,
      posterImg: "" /*播放器前贴图片*/,
      isLeftBottom:
        "true" /*播放按钮是否在播放器左下角,为true表示是，false表示播放按钮在播放器中间*/,
      isAudio: "false" /*是否是音频播放器,为true表示是音频，false表示是视频*/,
      isVod4k: "false" /*是否为4k播放器，true是4k,false不是*/,
      isHttps: isHttps /*是否https视频，true是,false不是*/,
      wmode: "opaque" /*flash播放器的窗口模式，默认为opaque*/,
      wideMode: "normal" /*flash播放器的窗口模式，默认为opaque*/,
      listMode:
        "false" /*点播播放器初始化参数：是否列表模式，默认false，false时不显示下一集按钮，不发送新增的下一集事件，设置中没有“自动播放下一集”选项；字符串类型*/,
      nextTitle: "" /*下一集标题，与listMode 配对使用*/,
      nextThumbnail: "" /*下一集预览图URL，与listMode 配对使用*/,
      setupOn: "true" /*是否显示设置按钮，默认为false*/,
      speedOn: "true" /*PC版h5播放器的倍速设置按钮，默认为true*/,
      hasBarrage:
        "false" /*是否有弹幕功能，默认false，false时不显示弹幕、不显示弹幕设置按钮、不显示弹幕开关、不访问弹幕接口和表情包配置接口e*/,
      barrageApp: "" /*弹幕数据获取接口，固定或者初始化时传入*/,
      playerType: "vod_h5" /*播放器类型，vod表示普通播放器*/,
      webFullScreenOn: "false" /*是否显示全屏按钮，默认true表示显示*/,
      language: "" /*语言，默认中文，en表示英语*/,
      other: "" /*其它参数*/,
    };


    if (typeof vodh5player !== "undefined" && vodh5player) {
      this.player_single = vodh5player.namespace.getVodPlayer();
   
      if (this.player_single) {
        vodh5player.namespace.dispose(this.player_single);
      }
    }

    //销毁点播，适用于移动端
    if(typeof destroyH5VodHls!=="undefined" && typeof vodPlayerObjs!=="undefined" && vodPlayerObjs[playerParas.divId]) {
      destroyH5VodHls(vodPlayerObjs[playerParas.divId], "destroyplayer"); //divId为播放器容器id
    }

    document.getElementById(playerParas.divId).innerHTML = ""; //divId为播放器容器id

    createVodPlayer(playerParas);
  },
  methods: {
    closeVideo() {
      this.$emit("closeVideo");
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.video-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10000;
  .video-box-bg {
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.6);
    position: absolute;
    top: 0;
    left: 0;
  }
  .video-area {
    // width: 960px;
    // height: 540px;
    width:9.6rem   !important;
    height: 5.4rem !important;
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    &.isC{
      width:5.4rem  !important;
    height:9.6rem  !important;
    }
  }
  .video-close {
    position: absolute;
    right: 50%;
    top: 50%;
    margin-top: -3.5rem;
    margin-right: -5rem;
    width: 0.6rem;
    height: 0.6rem;
    background: url("../../assets/img/close-btn.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 1000;
  }
  .video-close-btn{
    position: absolute;
    right: 50%;
    top: 50%;
    margin-top: 5rem;
    margin-right: -1.82rem;
    width: 3.64rem;
    height: 1.24rem;
    font-size: 0.36rem;
    line-height: 1.1rem;
    color: #fff;
    background: url("../../assets/img/btn-bg.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 1000;
  }
}
</style>